import { BaseRequest } from '@/network/requests/BaseRequest';
import { serious_defect } from '@/interfaces/serious_defect';

export const seriousDefectRequest = BaseRequest.build<serious_defect>('serious_defect');